import { formatCurrency, formatNumber } from "./analyticsFormat";

// 0024/0025: top customers by ex-VAT volume over the trend window. `accent` (e.g. "green")
// adds a semantic accent rail — these are the healthy/valuable customers.
const CustomersTable = ({ title, rows, accent }) => (
  <div className={`analyticsTableCard${accent ? ` analyticsTableCard--${accent}` : ""}`}>
    <h3 className="analyticsCardTitle">{title}</h3>
    {!rows || rows.length === 0 ? (
      <p className="analyticsEmpty">אין נתונים להצגה</p>
    ) : (
      <table className="analyticsTable">
        <thead>
          <tr>
            <th>לקוח</th>
            <th>מחזור (₪, לפני מע״מ)</th>
            <th>הזמנות</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.customerId}>
              <td>{r.name}</td>
              <td>{formatCurrency(r.volume)}</td>
              <td>{formatNumber(r.orders)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </div>
);

export default CustomersTable;
